import { render, staticRenderFns } from "./authNavigation.vue?vue&type=template&id=4d1337f5&"
import script from "./authNavigation.vue?vue&type=script&lang=js&"
export * from "./authNavigation.vue?vue&type=script&lang=js&"
import style0 from "./authNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports